/* ============================================================
   INDUS ORIGIN CO — About page behaviour
   Runs on page load AND on Shopify theme-editor events, so
   sections re-initialise when a merchant edits or reorders them.
   ============================================================ */
(function () {
  'use strict';

  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---------- scroll reveal ---------- */
  function initReveal(scope) {
    var items = scope.querySelectorAll('[data-io-reveal]:not(.is-in)');
    if (!items.length) return;

    if (reduce || !('IntersectionObserver' in window)) {
      items.forEach(function (el) { el.classList.add('is-in'); });
      return;
    }

    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        var el = entry.target;
        var index = Array.prototype.indexOf.call(el.parentNode.children, el) % 5;
        el.style.transitionDelay = (index * 80) + 'ms';
        el.classList.add('is-in');
        observer.unobserve(el);
      });
    }, { threshold: 0.15, rootMargin: '0px 0px -60px 0px' });

    items.forEach(function (el) { observer.observe(el); });
  }

  /* ---------- animated stat counters ---------- */
  function runCounter(el) {
    var raw = el.getAttribute('data-io-count') || '';
    var target = parseFloat(raw.replace(/[^0-9.]/g, ''));
    var suffix = el.getAttribute('data-io-suffix') || '';

    if (isNaN(target)) { el.textContent = raw + suffix; return; }
    if (reduce) { el.textContent = target.toLocaleString('en-IN') + suffix; return; }

    var start = performance.now();
    var duration = 1400;

    function tick(now) {
      var progress = Math.min((now - start) / duration, 1);
      var eased = 1 - Math.pow(1 - progress, 3);
      el.textContent = Math.round(target * eased).toLocaleString('en-IN') + (progress === 1 ? suffix : '');
      if (progress < 1) requestAnimationFrame(tick);
    }
    requestAnimationFrame(tick);
  }

  function initCounters(scope) {
    var counters = scope.querySelectorAll('[data-io-count]:not([data-io-done])');
    if (!counters.length) return;

    if (!('IntersectionObserver' in window)) {
      counters.forEach(function (el) { el.setAttribute('data-io-done', ''); runCounter(el); });
      return;
    }

    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        entry.target.setAttribute('data-io-done', '');
        runCounter(entry.target);
        observer.unobserve(entry.target);
      });
    }, { threshold: 0.6 });

    counters.forEach(function (el) { observer.observe(el); });
  }

  /* ---------- marquee ----------
     The merchant adds each word once; we clone the track so the
     loop is seamless no matter how many blocks they added.       */
  function initMarquee(scope) {
    scope.querySelectorAll('[data-io-marquee]:not([data-io-ready])').forEach(function (track) {
      if (!track.children.length) return;
      track.setAttribute('data-io-ready', '');
      var original = track.innerHTML;
      // repeat until the track is at least twice the viewport, then mirror once
      while (track.scrollWidth < window.innerWidth * 2) {
        track.insertAdjacentHTML('beforeend', original);
      }
      track.insertAdjacentHTML('beforeend', track.innerHTML);
    });
  }

  function initAll(scope) {
    var root = scope || document;
    initReveal(root);
    initCounters(root);
    initMarquee(root);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(document); });
  } else {
    initAll(document);
  }

  /* ---------- Shopify theme editor hooks ---------- */
  document.addEventListener('shopify:section:load', function (event) { initAll(event.target); });
  document.addEventListener('shopify:section:select', function (event) { initAll(event.target); });
  document.addEventListener('shopify:block:select', function (event) {
    var el = event.target.closest('[data-io-reveal]');
    if (el) el.classList.add('is-in');
  });
})();
